/**
 * Package-owned profile avatar with an initials fallback.
 */

interface ProfileAvatarProps {
  /** Uploaded profile image URL, when available. */
  imageUrl?: string;
  /** Current profile first name. */
  firstName?: string;
  /** Current profile last name. */
  lastName?: string;
}

/**
 * Render the uploaded profile image or a stable initials placeholder.
 *
 * @param props - Profile image and display-name fields
 * @returns Profile avatar content without relying on host public assets
 */
export function ProfileAvatar({
  imageUrl,
  firstName,
  lastName,
}: ProfileAvatarProps) {
  if (imageUrl) {
    return <img src={imageUrl} alt="Profile" />;
  }

  const initials =
    `${firstName?.charAt(0) ?? ""}${lastName?.charAt(0) ?? ""}`.toUpperCase() ||
    "U";

  return (
    <span
      className="profile-avatar-fallback"
      aria-label="Default profile avatar"
    >
      {initials}
    </span>
  );
}
